<script setup lang="ts">
import StatusTag from "~/components/Common/StatusTag.vue";
import Tooltip from "~/components/Common/Tooltip.vue";
import { useLearningPathAttendees } from "~/composables/learning-path/useLearningPathAttendees";
import { useFormats } from "~/composables/utils/useFormat";

const { toDateDisplay } = useFormats();
defineProps({
  row: { type: Object },
});

const { headersJourney, statusMapping } = useLearningPathAttendees();
</script>
<template #row="{ row }">
  <td v-if="headersJourney[0]?.visible">
    <div class="index_row">
      <span class="body_regular">{{ row?.trainingName ?? "-" }}</span>
    </div>
  </td>
  <td v-if="headersJourney[1]?.visible">
    <div v-if="row?.bookingStatus" class="index_row">
      <StatusTag :tag="statusMapping(row.bookingStatus)"></StatusTag>
    </div>
    <div v-else class="index_row gap-1">
      <span class="body_regular">À inscrire</span>
      <Tooltip :position="'top-mid'" append-to-body minified>
        <template #content>
          <div class="flex w-[414px] gap-[8px]">
            <img src="/icons/emojis/eyes.svg" alt="" :style="{ height: '16px', width: '16px' }" />
            <span class="body_regular">
              Aucune date de session n'a été définie pour cette formation. Pour inscrire le participant à une session,
              rendez-vous dans l'onglet « Formations ».
            </span>
          </div>
        </template>
      </Tooltip>
    </div>
  </td>
  <td v-if="headersJourney[2]?.visible">
    <div class="index_row">
      <span class="body_regular">{{ row?.startDate ? toDateDisplay(row?.startDate) : "-" }}</span>
    </div>
  </td>
  <td v-if="headersJourney[3]?.visible">
    <div class="index_row">
      <span v-if="Number.isFinite(row?.completionRate)" class="body_regular">{{ row?.completionRate }}%</span>
      <span v-else class="body_regular">-</span>
    </div>
  </td>
  <td v-if="headersJourney[4]?.visible">
    <div class="index_row">
      <span class="body_regular">{{
        row?.durationHours && Number.isFinite(row?.durationHours)
          ? `${row?.attendedHours ?? 0}/${row?.durationHours}h`
          : "-"
      }}</span>
    </div>
  </td>
  <td v-if="headersJourney[5]?.visible">
    <div class="index_row">
      <span class="body_regular">{{ row?.score && Number.isFinite(row?.score) ? `${row?.score}%` : "-" }}</span>
    </div>
  </td>
</template>
<style scoped lang="scss"></style>
